"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_config_1 = require("../../../service-lib/src/lib/database/typeorm.config");
const app_controller_1 = require("./app.controller");
const app_service_1 = require("./app.service");
const knowledge_module_1 = require("./knowledge/knowledge.module");
const service_communication_1 = require("../../../service-lib/src/lib/service-communication");
const environment_1 = require("../../../service-lib/src/lib/environment");
let AppModule = class AppModule {
    constructor(serviceRegistrationService) {
        this.serviceRegistrationService = serviceRegistrationService;
    }
    async onModuleInit() {
        const serviceInfo = {
            name: "knowledge-service",
            url: `${environment_1.ENV.URL_KNOWLEDGE_SERVICE}`,
            port: environment_1.ENV.PORT_KNOWLEDGE_SERVICE,
            healthCheck: "/health",
            status: "active",
        };
        await this.serviceRegistrationService.registerService(serviceInfo);
    }
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forRoot(typeorm_config_1.typeOrmConfig), knowledge_module_1.KnowledgeModule],
        controllers: [app_controller_1.AppController],
        providers: [app_service_1.AppService, service_communication_1.ServiceRegistrationService],
    }),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof service_communication_1.ServiceRegistrationService !== "undefined" && service_communication_1.ServiceRegistrationService) === "function" ? _a : Object])
], AppModule);
